<template>
  <div>
    <div class="pending-resources">
      <label>Number of Pending Resources: {{getPendingResources.length}}</label>
      <label v-if="complete">{{label}}</label>
    </div>
    <button class="button" @click="fetchPendingList">Fetch Pending list</button>
    <button class="clear-button" v-if="pendingResources && !complete" @click="clearPendingResources">Clear Pending
      Resources
    </button>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import * as moderationStatus from '../../enums/moderation-status'
  import * as _ from 'lodash'

  export default {
    name: 'clear-resources',
    data() {
      return {
        complete: false,
        PENDING: moderationStatus.PENDING.toUpperCase(),
        label: 'Resources have been removed.'
      }
    },
    computed: {
      ...mapGetters(['getPendingResourcesLoading', 'getPendingResources']),
      pendingResources() {
        return this.getPendingResources.length > 0
      }
    },
    methods: {
      ...mapActions(['deletePendingResources', 'fetchModeratedResources']),
      clearPendingResources() {
        this.deletePendingResources()
          .then(() => {
            this.complete = true
          })
      },
      fetchPendingList() {
        if (_.isEmpty(this.getPendingResources)) {
          this.fetchModeratedResources({status: this.PENDING, nextPageToken: null})
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../styles/colours.scss';

  .clear-button {
    width: 200px;
    height: 40px;
    border-radius: 2px;
    box-shadow: 0 1px 3px 0 $drop-shadow-black;
    border: solid 2px $input-warning;
    background-color: $input-warning;
    color: white;
    font-size: 14px;
    font-weight: bold;

    &:hover {
      box-shadow: 3px 5px 8px 0 $drop-shadow-black;
      border: solid 2.8px white;
      background-color: white;
      color: $input-warning;
    }
  }

  .button {
    width: 200px;
    height: 40px;
    border-radius: 2px;
    border: solid 2px white;
    font-size: 14px;
    font-weight: bold;
    color: $content-text;
    background-color: white;

    &:hover {
      border-radius: 2px;
      box-shadow: 3px 5px 8px 0 rgba(0, 0, 0, 0.24);
      border: solid 2.8px white;
      background-color: white;
      color: $content-text;
    }
  }
  .pending-resources{
    padding-bottom: 20px;
    font-size: 16px;
  }
</style>
